<div class="sh-progress-status -sh-full-width">
    <label for="status-demo-el-type" class="sh-progress-status__label"><ng-content></ng-content></label>
    <progress id="status-demo-el-type" [class]="labelClass" [value]="percentage" max="100">{{percentage}}%</progress>
</div>
